import React from "react";
import ProductForm from "./ProductForm";
import Modal from "../../shared/Modal";
import { useTranslation } from "react-i18next";
import { useSnackbar } from "notistack";
import { useMutation, useQueryClient } from "react-query";
import { addProduct } from "../../../api";
import queryKeys from "../../../api/queryKeys";

const DEFAULT_LANGUAGES = ["en-GB", "de-DE", "it-IT", "de-IT"];

const AddProductModal = ({ onClose, open }) => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const queryClient = useQueryClient();

  const { mutate: handleAdd, isLoading } = useMutation(
    ({ shared, langValues }) => {
      const langs = Object.keys(langValues);
      const requests = langs.map((lang) => {
        const langFields = langValues[lang] || {};
        return addProduct({
          ...shared,
          ...langFields,
          language: lang,
        });
      });
      return Promise.all(requests);
    },
    {
      onSuccess: () => {
        onClose();
        enqueueSnackbar(t("ADDED_PRODUCT"), { variant: "success" });
        queryClient.invalidateQueries({ queryKey: [queryKeys.PRODUCTS] });
      },
      onError: () => {
        enqueueSnackbar(t("ERROR_DEFAULT"), { variant: "error" });
      },
    }
  );

  return (
    <Modal
      onClose={onClose}
      open={open}
      title={t("ADD_PRODUCT")}
      fullWidth
      maxWidth="md"
    >
      <ProductForm
        handleSubmit={(values) => handleAdd(values)}
        isLoading={isLoading}
        buttonText={t("ADD")}
        productVariants={[]}
        mode="add"
      />
    </Modal>
  );
};

export default AddProductModal;
